<template>
  <div ref="bell" class="relative select-none"  v-outside:click="{ exclude: ['bell'], handler: close }">
    <span @click="toggle" class="flex items-center justify-center relative transition-all duration-150 w-10 h-10 flex-shrink-0 rounded-full bg-secondary-50 hover:bg-secondary hover:text-white text-secondary cursor-pointer">
      <base-icon name="bell" />
      <span v-if="isNotEmpty" class="w-4 h-4 rounded-full bg-red-600 absolute top-0 -right-1 border-2 border-white" />
    </span>
    <NotificationsModal :data="notifications" :toggleModal="toggleStatus" @toggle="toggle" @select="onSelect" />
  </div>
</template>

<script>
import NotificationsModal from '@/components/NotificationListModal.vue'
export default {
  name: 'NotificationsBox',
  components: {
    NotificationsModal
  },
  props: {
    notifications: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      toggleStatus: false
    }
  },
  computed: {
    isNotEmpty: function () {
      return this.notifications.length > 0
    }
  },
  methods: {
    toggle: function () {
      this.toggleStatus = !this.toggleStatus
    },
    close: function () {
      this.toggleStatus = false
    },
    onSelect: function (item) {
      this.toggleStatus = false
      this.$emit('select', item)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
